/**
 * Re-scoring (task 44, decision 0026). An assessment keeps the configuration it started on; a re-score
 * moves chosen assessments onto the live configuration. It is proposed with a dry run of every score it
 * would change and applied only once two people other than the one who proposed it approve.
 */
import { can } from './rbac.js';
/** Distinct approvers a re-score needs, none of them its requester. */
export const RESCORE_APPROVALS = 2;
/** What a re-score would do across the book, for the approvers. */
export function summarizeRescore(lines) {
    const s = { assessments: lines.length, up: 0, down: 0, same: 0, band_changes: 0, newly_capped: 0, uncapped: 0, biggest_drop: 0, biggest_rise: 0, mean_change: 0 }; // prettier-ignore
    let total = 0;
    let scored = 0;
    for (const l of lines) {
        const delta = l.from_score === null ? null : l.to_score - l.from_score;
        if (delta === null || delta === 0)
            s.same += 1;
        else if (delta > 0)
            s.up += 1;
        else
            s.down += 1;
        if (delta !== null) {
            scored += 1;
            total += delta;
            s.biggest_drop = Math.max(s.biggest_drop, -delta);
            s.biggest_rise = Math.max(s.biggest_rise, delta);
        }
        if (l.from_band !== null && l.from_band !== l.to_band)
            s.band_changes += 1;
        if (l.from_cap === null && l.to_cap !== null)
            s.newly_capped += 1;
        if (l.from_cap !== null && l.to_cap === null)
            s.uncapped += 1;
    }
    s.mean_change = scored ? Math.round(total / scored) || 0 : 0; // never -0
    return s;
}
/**
 * Whether a person may approve: staff, not the requester, not already approved. Returns the reason they
 * can't, or null.
 */
export function rescoreApprovalProblem(r, user) {
    if (r.status !== 'pending')
        return `This re-score was already ${r.status}`;
    if (!can(user.permissions, 'rescores.approve'))
        return 'Your role doesn’t approve re-scores';
    if (r.requested_by === user.id)
        return 'You proposed this re-score; two other people must approve it';
    if (r.approvals.some((a) => a.approver === user.id))
        return 'You have already approved it';
    return null;
}
//# sourceMappingURL=rescores.js.map